<div class="text-holder">
  <span>Storage Usage</span>
</div>
<mat-progress-bar [mode]="hasStorageUsage() ? 'determinate' : 'indeterminate'" [color]="storageBarColor()" [value]="storageUsage()?.storageUsedPercentage ?? 0"></mat-progress-bar>
<div class="text-holder">
  @if (hasStorageUsage()) {
    <span>Using {{ storageUsage()!.storageUsed | fileSize }} of {{ storageUsage()!.storageTotal | fileSize }}</span>
  }
  @if (hasStorageUsage()) {
    <span>Available Space {{ storageUsage()!.storageAvailable | fileSize }}</span>
  }
</div>
